import styled from 'styled-components'

export const Themed = styled.div`
  * {
    &:not(i) {
      font-family: ${(props) => props.theme.font.body};
    }
  }
`
